/**
 * Given a decimal between 0 and 1,
 * returns an hex number between 00 and FF
 * @param {Number} decimal 
 * @returns {String}
 */
export const decimalToHexStr = (decimal) => {
  return Math.floor(decimal * 255).toString(16)
}